import { useDesignMaxTheme } from "@/packages";
import { Center, Flex, Grid, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";
import { CustomTitle } from "./guideDetail.style";
import { type GuideDetailProps } from "./guideDetail.type";

export const GuideDetail = ({ data }: GuideDetailProps) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isTablet } = MEDIAS();

    return (
        <Center
            maxW="1600px !important"
            w="100%"
            as="section"
            flexDir="column"
            rowGap={isTablet ? "32px" : "64px"}
            p={isMobile ? "24px 0" : "120px 0"}
        >
            <Flex
                flexDir="column"
                p={isMobile ? "0 16px" : "0 48px"}
                sx={{
                    "& p": {
                        color: "#664628",
                    },
                }}
            >
                <CustomTitle fontFamily="Cormorant">Pension Notice</CustomTitle>
                <Text fontFamily="Cormorant">예약 상세안내</Text>
            </Flex>
            <Grid
                p={isMobile ? "0 16px" : "0 48px"}
                w="100%"
                gridTemplateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(2, 1fr)"}
                gridGap="40px"
            >
                <Flex flexDir="column" gap="24px">
                    <Text>● 추가 비용 안내</Text>
                    <Text
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(data.cost.replace(/\r?\n/g, "<br />")),
                        }}
                    />
                </Flex>
                <Flex flexDir="column" gap="24px">
                    <Text>● 부대 시설 안내</Text>
                    <Text
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(data.facility.replace(/\r?\n/g, "<br />")),
                        }}
                    />
                </Flex>
                <Flex flexDir="column" gap="24px">
                    <Text>● 예약 유의 사항</Text>
                    <Text
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(data.reserve.replace(/\r?\n/g, "<br />")),
                        }}
                    />
                </Flex>
                <Flex flexDir="column" gap="24px">
                    <Text>● 숙소 이용 안내</Text>
                    <Text
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(data.notice.replace(/\r?\n/g, "<br />")),
                        }}
                    />
                </Flex>
            </Grid>
        </Center>
    );
};
